import GoogleMap from '../Google'
import { SearchControlProps } from '../Google/PlaceSearchControl'
import { useInnmaxMap } from '../Provider'
import { MapType } from '../map.types'

type IPlaceSearchControlProps = SearchControlProps

const InnmaxPlaceSearchControl = (props: IPlaceSearchControlProps) => {
  const { mapPlatform, mapType } = useInnmaxMap()

  if (mapType === MapType.Upload || mapPlatform === 'MapLibre') {
    return null
  }
  return <GoogleMap.PlaceSearchControl {...props} />
}

export default InnmaxPlaceSearchControl
